import { Document, Page, View, pdf } from "@react-pdf/renderer";
import { toast } from "react-toastify";
import { ANDROID, IOS, WINDOWS } from "../components/helper/constants";
import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";

export function FileDownload(url, name) {
  if (url) {
    const link = document.createElement("a");
    link.href = url;
    link.download = name ? name : url.split("?")[0].split("/").at(-1); // Extract name from url if name not passed
    link.click();
    link.remove();
  }
}

const MyPdfDocument = (pdfBody) => (
  <Document>
    <Page>
      <View>{pdfBody}</View>
    </Page>
  </Document>
);

export const getPdfForScene = async (pdfBody) => {
  const pdfBlob = await pdf(MyPdfDocument(pdfBody)).toBlob();
  return URL.createObjectURL(pdfBlob);
};

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function copyToClipBoard(value) {
  window.navigator.clipboard?.writeText(value);
}

export const SuccessToastMessage = (message) => {
  toast.success(message, {});
};

export const ErrorToastMessage = (message) => {
  toast.error(message, {});
};

export const WarningToastMessage = (message) => {
  toast.warning(message, {});
};

export function toggleFullScreen(elem, setFullScreen) {

  if (
    (document.fullScreenElement !== undefined &&
      document.fullScreenElement === null) ||
    (document.msFullscreenElement !== undefined &&
      document.msFullscreenElement === null) ||
    (document.mozFullScreen !== undefined && !document.mozFullScreen) ||
    (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)
  ) {
    if (elem.requestFullScreen) {
      elem.requestFullScreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullScreen) {
      elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
    setFullScreen(true);
  } else {
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }

    setFullScreen(false);
  }
}

export function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
      return ANDROID;
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return IOS;
  }

  return null;
}

export const checkIfSelectedHelper = (uuid, value, data) => {
  const { currentVariation, currentUpholstery, currentLegFinish, currentLegPaintColor, currentPaintColor,
      currentWoodTop, currentCushion, currentHeadboardFabric, currentMetalLegs, currentBambooBedPaint,
      currentRetreatFabrics, currentRetreatLegFinish, currentWelt, currentTurnedLegFinish,
      currentLatticeCollectionPaintColors, currentChairFrame } = data;
  let response = false;
  switch (value) {
      case "Variation":
          response = currentVariation === uuid;
          break;
      case "Upholstery":
          response = currentUpholstery === uuid;
          break;
      case "Leg_Finish":
          response = currentLegFinish === uuid;
          break;
      case "Leg_Finish_Paint_Color":
          response = currentLegPaintColor === uuid;
          break;
      case "Paint_Color":
          response = currentPaintColor === uuid;
          break;
      case "Cushion":
          response = currentCushion === uuid;
          break;
      case "Wood_Top":
          response = currentWoodTop === uuid;
          break;
      case "Headboard_Fabric":
          response = currentHeadboardFabric === uuid;
          break;
      case "Metal_Legs":
          response = currentMetalLegs === uuid;
          break;
      case "Bamboo_Bed_Paint":
          response = currentBambooBedPaint === uuid;
          break;
      case "Retreat_Fabrics":
          response = currentRetreatFabrics === uuid;
          break;
      case "Retreat_Leg_Finish":
          response = currentRetreatLegFinish === uuid;
          break;
      case "Welt":
          response = currentWelt === uuid;
          break;
      case "Turned_Leg_Finish":
          response = currentTurnedLegFinish === uuid;
          break;
      case "Lattice_Collection_Paint_Colors":
          response = currentLatticeCollectionPaintColors === uuid;
          break;
      case "Chiar_Frame":
          response = currentChairFrame === uuid;
          break;
      default:
          response = false;
          break;
  }
  return response;
};

export const getYourKey = (value) => {
  switch(value) {
    case 'Upholstery_Data': {
      return 'upholsteryData'
    }
    case 'Leg_Finish_Data': {
      return 'legFinishData'
    }
    case 'Leg_Finish_Paint_Color_Data': {
      return 'legFinishPaintColorData'
    }
    case 'Paint_Color_Data': {
      return 'paintColorData'
    }
    case 'Cushion_Data': {
      return 'cushionData'
    }
    case 'Wood_Top_Data': {
      return 'woodTopData'
    }
    case 'Headboard_Fabric_Data': {
      return 'headboardFabricData'
    }
    case 'Metal_Legs_Data': {
      return 'metalLegsData'
    }
    case 'Bamboo_Bed_Paint_Data': {
      return 'bambooBedPaintData'
    }
    case 'Retreat_Fabrics_Data': {
      return 'retreatFabricsData'
    }
    case 'Retreat_Leg_Finish_Data': {
      return 'retreatLegFinishData'
    }
    case 'Welt_Data': {
      return 'weltData'
    }
    case 'Turned_Leg_Finish_Data': {
      return 'turnedLegFinishData'
    }
    case 'Lattice_Collection_Paint_Colors_Data': {
      return 'latticeCollectionPaintColorsData'
    }
    case 'Chair_Frame_Data': {
      return 'chairFrameData'
    }
    default: {
      console.log("no match")
    }
  }
}

// get open mode
const searchParams = new URLSearchParams(window.location.search);
export const isDebugMode = searchParams.get("mode") && searchParams.get("mode") === "debug";
export const isConfiguratorMode = searchParams.get("mode") && searchParams.get("mode") === "configurator";

export const parseFloatValue = (v) => Number.parseFloat(v).toFixed(3);
export async function handleExportGLTF({
  currentScene,
  scene,
  fileName,
  setLoading,
}) {
  console.log("dekho : scene", scene);
  console.log("dekho : model", currentScene);
  setLoading?.(true);
  const gltfExporter = new GLTFExporter();
  const gltf = await new Promise((resolve) => {
    gltfExporter.parse(currentScene, (result) => {
      console.log("Parsed GLTF result:", result);
      resolve(result);
    });
  });

  const blob = new Blob([JSON.stringify(gltf)], { type: "model/gltf" });
  const fileFormData = new FormData();
  fileFormData.append("file_url_key", `${fileName}.glb`);
  try {
    const createFileSpaceResponse = await fetch(
      "https://prod.imagine.io/users/api/v3/public/dynamic-ar-data/",
      {
        method: "POST",
        body: fileFormData,
      }
    ).then((res) => res.json());
    if (!createFileSpaceResponse) {
      return;
    }
    const { data } = createFileSpaceResponse || {};
    const unicodeApiUrl =
      "https://prod.imagine.io/users/api/v3/public/dynamic-ar-data/?unicode=" +
      data?.unicode;
    const presignedUrlData = data?.presigned_url_file;
    const presignedFields = presignedUrlData.fields;
    console.log({
      createFileSpaceResponse,
      unicodeApiUrl,
      presignedUrlData,
      presignedFields,
    });
    const fileUploadFormData = new FormData();
    for (const key in presignedFields) {
      fileUploadFormData.append(key, presignedFields[key]);
    }
    fileUploadFormData.append("file", blob, `${fileName}.glb`);
    // Here, we are uploading the file to S3 using the presigned URL
    const uploadedFileResponse = await fetch(presignedUrlData.url, {
      method: "POST",
      body: fileUploadFormData,
    });
    if (!uploadedFileResponse.ok) {
      throw new Error("Failed to upload file to S3");
    }
    console.log("File uploaded to S3");
    // Here, we are fetching the file from S3 using the unicode API
    const fileFetchedViaUnicode = await fetch(unicodeApiUrl).then((r) =>
      r.json()
    );
    console.log("DEBUG__finalData", {
      fileFetchedViaUnicode,
      uploadedFileResponse,
      unicodeApiUrl,
    });
    setLoading?.(false);
    return {
      file: fileFetchedViaUnicode?.data?.file,
      unicode: data?.unicode,
    };
  } catch (error) {
    console.error("Error:", error);
    setLoading?.(false);
  }
}
export const isAndroid = () => navigator.userAgent.match(/Android/i);